module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi4-ce0bfcffe25072182ee005d96d3d765b.jpg";